export enum EnVideoType {
    mp4 = 'video/mp4',
    webm = 'video/webm',
    ogg = 'video/ogg'
}
